import React from 'react';

interface TabProps {
  label: string;
  children: React.ReactNode;
}

export function Tab({ children }: TabProps) {
  return <>{children}</>;
}

interface TabsProps {
  active: number;
  onSelect: (index: number) => void;
  children: React.ReactElement<TabProps>[];
}

export function Tabs({ active, onSelect, children }: TabsProps) {
  const tabs = React.Children.toArray(children) as React.ReactElement<TabProps>[];

  return (
    <div>
      <div role="tablist" className="flex border-b border-gray-200 mb-4">
        {tabs.map((tab, i) => (
          <button
            key={i}
            role="tab"
            aria-selected={i === active}
            aria-label={tab.props.label}
            onClick={() => onSelect(i)}
            className={`px-4 py-2 text-sm font-medium transition-colors ${
              i === active
                ? "border-b-2 border-orange-600 text-orange-600"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            {tab.props.label}
          </button>
        ))}
      </div>
      <div role="tabpanel">{tabs[active]}</div>
    </div>
  );
}
